import React from "react";

import SrrRowBase from "./SrrRowBase";

const ReportReturnSRR3ForPayments = ({ row, items, group }) => {
  const dealerArr = ["DealerName", "INN", "ent_id", "subject", "FO", "city"];

  let optionsTable = dealerArr.map((el) => row[el]);
  const lastItem = {
    sumServiceCount: 0,
    sumSaleCount: 0,
    sumTarget: 0,
    sumPercent: 0,
    sumPercentTarget: 0,
  };
  const renderItem = [
    ...row.periods
      .map((el) => {
        lastItem.sumServiceCount += el.countService;
        lastItem.sumSaleCount += el.countSale;
        lastItem.sumTarget += el.target;
        lastItem.sumPercent += el.percent;
        lastItem.sumPercentTarget += el.percentTarget;

        return [
          el.target,
          el.countSale,
          el.countService,
          el.percent,
          el.percentTarget,
        ];
      })
      .flat(),
    lastItem.sumTarget,
    lastItem.sumSaleCount,
    lastItem.sumServiceCount,
    ((lastItem.sumServiceCount / lastItem.sumSaleCount) * 100).toFixed(2),
    lastItem.sumPercentTarget,
  ];

  return <SrrRowBase leadingCells={optionsTable} cells={renderItem} />;
};

export default ReportReturnSRR3ForPayments;
